import React, { useEffect } from "react";
import {
  GeneralModal,
  GeneralTable,
  useModalAlert,
} from "../GeneralComponents";
import moment from "moment";

export default function ActualizarVersion({
  openModal,
  handleCloseModal,
  documentoSeleccionado,
  loadDocumentos
}) {
  const [versionSeleccionado, setVersionSeleccionado] = React.useState(null);
  const [isEditMode, setIsEditMode] = React.useState(true);
  const [versiones, setversiones] = React.useState([]);
  const [formData, setFormData] = React.useState({
    fecha_creacion: moment(),
    version: "",
    descripcion_cambio: "",
    item_pagina: "",
  });
  const { showModalAlert } = useModalAlert();

  const newModalField = [
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      type: "date",
    },
    { name: "version", label: "Versión", type: "text" },
    {
      name: "descripcion_cambio",
      label: "Descripción del cambio",
      type: "text",
    },
    { name: "item_pagina", label: "Item/página", type: "text" },
    {
      name: "documento_version",
      label: "Archivo Adjunto",
      type: "file",
      accept: ".pdf",
    },
  ];

  async function handleSaveDocument(formData) {
    let usuario = JSON.parse(sessionStorage.getItem("usuario"));

    try {
      const fd = new FormData();
      const {
        fecha_creacion,
        version,
        descripcion_cambio,
        item_pagina,
        documento_version,
        ...rest
      } = formData || {};

      // fecha_creacion: convert moment or Date to ISO (or YYYY-MM-DD if you prefer)
      if (fecha_creacion) {
        let fechaStr = fecha_creacion;
        if (typeof fecha_creacion !== "string") {
          if (fecha_creacion.toISOString)
            fechaStr = fecha_creacion.toISOString();
          else fechaStr = moment(fecha_creacion).toISOString();
        }
        fd.append("fecha_creacion", fechaStr);
      }

      if (version) fd.append("version", version);
      if (descripcion_cambio)
        fd.append("descripcion_cambio", descripcion_cambio);
      if (item_pagina) fd.append("item_pagina", item_pagina);

      // Attach file (handle File, FileList or array)
      if (documento_version) {
        let file = null;
        if (documento_version instanceof File) file = documento_version;
        else if (documento_version instanceof FileList)
          file = documento_version[0];
        else if (Array.isArray(documento_version) && documento_version.length)
          file = documento_version[0];

        if (file) fd.append("documento_version", file);
      }

      // Append any other remaining fields
      Object.keys(rest).forEach((key) => {
        if (rest[key] !== undefined && rest[key] !== null) {
          fd.append(
            key,
            typeof rest[key] === "object"
              ? JSON.stringify(rest[key])
              : String(rest[key])
          );
        }
      });

      // Append user and previous document as fields
      fd.append("id_usuario", usuario.id_usuario);
      fd.append("documento_anterior", JSON.stringify(documentoSeleccionado));
      fd.append(
        "id_documento_seleccionado",
        documentoSeleccionado.id_gd_documentos
      );

      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "version/create",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
            // Do NOT set Content-Type; browser will set multipart/form-data with boundary
          },
          body: fd,
        }
      );

      const result = await updateResponse.json();
      handleCloseModal();
      if (updateResponse.ok) {
        showModalAlert("success", "Se actualizó correctamente la versión");
        loadDocumentos();
      } else {
        showModalAlert(
          "danger",
          result?.message || "Error al actualizar la versión"
        );
      }
    } catch (error) {
      handleCloseModal();
      showModalAlert("danger", "Error al actualizar la versión");
      console.error(error);
    }
  }

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <>
      <GeneralModal
        open={openModal}
        titleAlert={"versión"}
        onClose={handleCloseModal}
        fields={newModalField}
        formData={formData}
        onFieldChange={handleFieldChange}
        setFormData={setFormData}
        onSave={handleSaveDocument}
        initialFormData={{
          serie_id: "",
          subserie_id: "",
          documentTypes: [],
        }}
        enableDocumentarytype={true}
        title={"Actualizar versión"}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
      />
    </>
  );
}
